import { graphql } from "@/gql";

export const CHECK_IN_REPORTS_QUERY = graphql(`
  query CHECK_IN_REPORTS_QUERY(
    $createdAt: CheckInReportsCreatedAtConditionInput
    $first: Int
    $offset: Int
    $orderBy: [CheckInReportsOrderBy!] = ID_DESC
    $organizationId: String!
    $requestorMemberId: String
    $search: String
  ) {
    checkInReports(
      first: $first
      offset: $offset
      condition: {
        createdAt: $createdAt
        organizationId: $organizationId
        requestorMemberId: $requestorMemberId
        shortId: $search
      }
      orderBy: $orderBy
    ) {
      totalCount
      edges {
        node {
          id
          organizationId
          shortId
          createdAt
          cutoffAt
          requestorMemberId
          requestorMember {
            id
            fullName
            displayName
            avatarUrl
            lastActiveAt
          }
          checkInRequests {
            totalCount
          }
          placeId
          place {
            id
            name
          }
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
    }
  }
`);
